import * as React from "react";
import { PropsWithChildren, useMemo } from "react";
import { LocationContext } from "./LocationContext";
import { useLocation } from "react-router-dom";

export const PACLocationProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  // use react router location state, but map to a Path interface which shares the same shape as window.location (for kids compatibility)
  const location = useLocation();
  const contextValue = useMemo(() => {
    const { pathname, search, hash } = location;
    return { pathname, search, hash };
  }, [location]);

  return (
    <LocationContext.Provider value={contextValue}>
      {children}
    </LocationContext.Provider>
  );
};
